<template>
    <div class="main-content__wizzard">
        <div v-if="!loading" class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                Basic organization details
            </h2>

            <input-field label="Organization name" type="text" :field="$v.organization.name"/>

            <h4 v-translate>
                Choose categories:
            </h4>

            <input-field label="Business" type="checkbox"
                     :field="$v.organization.category_business"/>
            <input-field label="Health" type="checkbox"
                     :field="$v.organization.category_health"/>
            <input-field label="Relationship" type="checkbox"
                     :field="$v.organization.category_relationship"/>
            <input-field label="Personal" type="checkbox"
                     :field="$v.organization.category_personal"/>


            <input-field label="Choose leader of organization (director, CEO, ...)" type="select2" :field="$v.organization.leader" :options="peopleOptions" search="true"/>

            <div class="form__action-buttons">
                <a @click="submit()" href="javascript:;" class="button button--primary" v-translate>Next step</a>
            </div>
        </div>
    </div>
</template>
<script>
    import InputField from "../../views/popups/InputField";
    import CategoryOptions from "../../mixins/CategoryOptions";
    import {required} from 'vuelidate/lib/validators';
    import axios from "axios";

    export default {
        name: 'plan-organization-step-one',
        mixins: [CategoryOptions],
        components: {InputField},
        data() {
            return {
                people: [],
                organization: {},
                loading: true,
            }
        },
        props: {
            parent_organization: {},
        },
        beforeMount: function () {
            this.organization = this.parent_organization
            this.loadPeople()
        },
        computed: {
            peopleOptions: function () {
                let opts = []
                for (let i = 0; i < this.people.length; i++) {
                    opts.push(
                        {id: this.people[i].id, text: this.people[i].first_name + " " + this.people[i].last_name}
                    )
                }
                return opts
            },
            iconClass: function () {
                if (this.organization.category == '') {
                    return 'main-category-icon--not-set'
                } else {
                    for (let i = 0; i < this.categories.length; i++) {
                        if (this.categories[i].id == this.organization.category) {
                            return 'icon-' + this.categories[i].icon
                        }
                    }
                }
                return 'main-category-icon--not-set'
            },
        },
        methods: {
            loadPeople: async function () {
                this.loading = true;
                this.people = (await axios.get('/api/navigator/people/')).data
                this.loading = false;
            },
            submit: function () {
                this.$v.$touch()
                if (this.organization.category_business | this.organization.category_health | this.organization.category_relationship | this.organization.category_personal){
                    if (!this.$v.$invalid) {
                        this.$emit('advance', 'step-2')
                    }
                }
            }
        },
        validations: {
            organization: {
                name: {required},
                category_business: {},
                category_health: {},
                category_relationship: {},
                category_personal: {},
                leader: {required}
            }
        }
    }
</script>
